import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireAllowedPersonalizedPlanSuperAdmin } from '@/lib/auth-guards'
import { PersonalizedPlansPage } from '@/features/personalized-plans'

const personalizedPlansSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  q: z.string().optional().catch(''),
  trainerId: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/personalized-plans/')({
  beforeLoad: requireAllowedPersonalizedPlanSuperAdmin,
  validateSearch: personalizedPlansSearchSchema,
  component: PersonalizedPlansPage,
})
